import React from "react";

function TempPage() {
    return (
        <h2 className="soldier-content">UNDER CONSTRUCTION</h2>
    )
}

export default TempPage;